import React from "react";


const SectionHeading = (props) => {
  return (
    <h1 className="QMF---SectionHeadeing mb-4">
       {props.title}
        <span>{props.subtitle}</span>
    </h1>
  );
}

export default SectionHeading;
